
import { Injectable, InjectionToken }  from '@angular/core';
import { AppConfig } from "app/export.interfaces";

@Injectable()
export class MyAppSharedSettings {
    baseUrlWebApi:string = "http://conf-pe.bremaud.loc";
}


export const DNN_AppConfig: AppConfig = {
    baseUrlWebApi: "http://conf-pe.bremaud.loc"
}

export let APP_CONFIG = new InjectionToken<AppConfig>('app.config');






// WEBPACK FOOTER //
// ./src/app/app.setting.ts